<script setup lang="js">
import { computed, ref, watch } from 'vue';
import { useElementSize } from '@vueuse/core';
import { storeToRefs } from 'pinia';
import _ from 'lodash';

import { useContextMenuStore } from '@/stores/contextMenu.store';

const ctxMenuStore = useContextMenuStore();
const { shown: ctxShown, position, menuItems } = storeToRefs(ctxMenuStore);

const ctxMenu = ref();
const { width: ctxWidth, height: ctxHeight } = useElementSize(
  ctxMenu,
  undefined,
  { box: 'border-box' }
);

const positionAsStyle = computed(() => {
  const { left, top } = position.value;
  const screenWidth = visualViewport.width;
  const screenHeight = visualViewport.height;

  const moveLeft = screenWidth < (left + ctxWidth.value + 20);
  const moveTop = screenHeight < (top + ctxHeight.value + 20);

  return {
    left: `${left - (moveLeft ? ctxWidth.value : 0)}px`,
    top: `${top - (moveTop ? ctxHeight.value : 0)}px`
  };
});

function handleItemClick(item) {
  if (_.isFunction(item.action)) {
    item.action();
  }

  ctxMenuStore.closeContextMenu();
}

watch(ctxShown, (value) => {
  if (!value) {
    document.body.classList.remove('modal-open');
    return;
  }

  document.body.classList.add('modal-open');
});
</script>

<template>
  <div v-if="ctxShown" @click="ctxMenuStore.closeContextMenu" class="ctxmenu-wrapper">
    <div ref="ctxMenu" @click.stop class='ctxmenu' :style="positionAsStyle">
      <div v-for="item in menuItems" class="ctxmenu-item w-100" :key="item.id">
        <slot :item="item" :close="ctxMenuStore.closeContextMenu">
          <div @click="handleItemClick(item)" class="w-100">
            {{ item.title }}
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>
